function markSerializable(fn) {
    fn.__qwik_serializable__ = true;
    return fn;
}

export const image = [{
    name: 'image',
    type: 'object',
    subFields: [{
            name: 'src',
            type: 'file',
            bubble: true,
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
            // required: true,
            defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2Fd09cfff8ac614d8a86e457a0274fa171%2F0d21e1eb1c5a47dcbacaeb00aa259826',
            onChange: markSerializable((options) => {
                const DEFAULT_ASPECT_RATIO = 0.7041;
                options.delete('srcset');
                options.delete('noWebp');

                function loadImage(url, timeout = 60000) {}

                function round(num) {
                    return Math.round(num * 1000) / 1000;
                }

                const value = options.get('image');
                const aspectRatio = options.get('aspectRatio');

                // For SVG images - don't render as webp, keep them as SVG
                fetch(value)
                    .then((res) => res.blob())
                    .then((blob) => {
                        if (blob.type.includes('svg')) {
                            options.set('noWebp', true);
                        }
                    });

                if (value && (!aspectRatio || aspectRatio === DEFAULT_ASPECT_RATIO)) {
                    return loadImage(value).then((img) => {
                        const possiblyUpdatedAspectRatio = options.get('aspectRatio');
                        if (
                            options.get('image') === value &&
                            (!possiblyUpdatedAspectRatio || possiblyUpdatedAspectRatio === DEFAULT_ASPECT_RATIO)
                        ) {
                            if (img.width && img.height) {
                                options.set('aspectRatio', round(img.height / img.width));
                                options.set('height', img.height);
                                options.set('width', img.width);
                            }
                        }
                    });
                }
            }),
        },
        {
            name: 'alt',
            type: 'string',
            // required: true,
        },
    ],
}, ];

export const video = [{
    name: 'video',
    friendlyName: 'Video',
    type: 'object',
    subFields: [{
            name: 'video',
            friendlyName: 'Video Url',
            type: 'url',
        },
        {
            name: 'poster',
            type: 'file',
            bubble: true,
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
            // required: true,
            defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2Fd09cfff8ac614d8a86e457a0274fa171%2F0d21e1eb1c5a47dcbacaeb00aa259826',
            onChange: markSerializable((options) => {
                const DEFAULT_ASPECT_RATIO = 0.7041;
                options.delete('srcset');
                options.delete('noWebp');

                function loadImage(url, timeout = 60000) {}

                function round(num) {
                    return Math.round(num * 1000) / 1000;
                }

                const value = options.get('image');
                const aspectRatio = options.get('aspectRatio');

                // For SVG images - don't render as webp, keep them as SVG
                fetch(value)
                    .then((res) => res.blob())
                    .then((blob) => {
                        if (blob.type.includes('svg')) {
                            options.set('noWebp', true);
                        }
                    });

                if (value && (!aspectRatio || aspectRatio === DEFAULT_ASPECT_RATIO)) {
                    return loadImage(value).then((img) => {
                        const possiblyUpdatedAspectRatio = options.get('aspectRatio');
                        if (
                            options.get('image') === value &&
                            (!possiblyUpdatedAspectRatio || possiblyUpdatedAspectRatio === DEFAULT_ASPECT_RATIO)
                        ) {
                            if (img.width && img.height) {
                                options.set('aspectRatio', round(img.height / img.width));
                                options.set('height', img.height);
                                options.set('width', img.width);
                            }
                        }
                    });
                }
            }),
        },
        {
            name: 'altText',
            friendlyName: 'Alt Text',
            type: 'string',
        },
    ],
}, ];

export const backgroundColor = [{
    name: 'backgroundColor',
    friendlyName: 'Background Color',
    type: 'string',
    defaultValue: 'chapati',
    enum: ['chapati', 'white'],
}, ];

export const button = [{
    name: 'button',
    friendlyName: 'Button',
    type: 'object',
    subFields: [{
            name: 'label',
            helperText: 'The text that will appear on the button',
            type: 'string',
        },
        {
            name: 'title',
            helperText: 'The title of the button, used for accessibility',
            type: 'string',
        },
        {
            name: 'url',
            type: 'url',
        },
        {
            name: 'target',
            type: 'boolean',
            helperText: 'Toggle to open internal link in a new tab. External links will always open in a new tab.',
        },
    ],
    defaultValue: {
        label: 'Button Label',
        title: 'Accessibility',
        url: 'https://inbound.com',
    },
}, ];

export const location = [{
    name: 'location',
    friendlyName: 'Location',
    type: 'object',
    subFields: [{
            name: 'label',
            helperText: 'The name of the location',
            type: 'string',
        },
        {
            name: 'street_address',
            helperText: 'The street address of the location',
            type: 'string',
        },
        {
            name: 'city',
            helperText: 'The city of the location',
            type: 'string',
        },
        {
            name: 'state',
            helperText: 'The state of the location',
            type: 'string',
        },
        {
            name: 'zip',
            helperText: 'The zip code of the location',
            type: 'string',
        },
    ],
    defaultValue: {
        label: 'Moscone Center',
        street_address: '747 Howard St',
        city: 'San Francisco',
        state: 'CA',
        zip: '94103'
    },
}, ];

export const headline = [{
    name: 'headline',
    friendlyName: 'Headline',
    type: 'string',
    defaultValue: 'Headline',
}, ];

export const anchor = [{
    name: 'anchorId',
    friendlyName: 'Anchor Hash',
    type: 'string',
    defaultValue: '',
    helperText: 'Can be used as a #hash in a URL to jump to this element and have it open by default',
}, ];

export const headlineSubhead = [
    ...headline,
    {
        name: 'subHead',
        friendlyName: 'Subhead Text',
        type: 'richText',
        defaultValue: 'Subhead Text',
    },
];

export const headlineCopy = [
    ...headline,
    {
        name: 'copy',
        friendlyName: 'Copy',
        type: 'richText',
        defaultValue: 'Copy',
    },
];

export const headlineSubheadCopy = [
    ...headline,
    {
        name: 'subHead',
        friendlyName: 'Subheadline',
        type: 'string',
    },
    {
        name: 'copy',
        friendlyName: 'Copy',
        type: 'richText',
        defaultValue: 'Copy',
    },
];

//Fragments

export const sponsorFields = [{
        name: 'name',
        friendlyName: 'Name',
        type: 'string',
    },
    {
        name: 'logo',
        friendlyName: 'Logo',
        type: 'file',
    },
    {
        name: 'link',
        friendlyName: 'Link',
        type: 'string',
    },
];

export const sponsorCategoryFields = {
    type: 'list',
    subFields: [...sponsorFields],
};

export const twoUpCard = {
    type: 'object',
    subFields: [...headlineCopy, ...image, ...button],
    defaultValue: {
        headline: 'Headline',
        copy: '<p>Copy</p>',
        image: {
            src: 'https://cdn.builder.io/api/v1/image/assets%2Fd09cfff8ac614d8a86e457a0274fa171%2F74d262c6c2694d38b3bc7f03063d276a',
            alt: 'Alt Text',
        },
        button: {
            label: 'Button Label',
            title: 'Button Title',
            url: 'https://inbound.com',
        },
    },
};

export const iconTitleContentCard = [...headlineCopy];

export const required = {
    name: 'required',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Is this field required?',
};

// Forms
